

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { EventCard } from './event-card';

import type { EntitySummary, EventSummary, NarrativeSummary } from '@/lib/types';

interface TimelineListViewProps {
  events: EventSummary[];
  scenes: NarrativeSummary[];
  locations: EntitySummary[];
  characters: EntitySummary[];
  organizations: EntitySummary[];
}

export function TimelineListView({
  events,
  scenes,
  locations,
  characters,
  organizations,
}: TimelineListViewProps) {
  if (events.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary">
          No events in this arc
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Try adjusting your filters or create a new event
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={0}>
      {events.map((event) => (
        <EventCard
          key={event.id}
          event={event}
          scenes={scenes}
          locations={locations}
          characters={characters}
          organizations={organizations}
        />
      ))}
    </Stack>
  );
}
